"use strict";
exports.__esModule = true;
exports.Expertise = void 0;
var Expertise;
(function (Expertise) {
    Expertise["AUDIOVISUAL"] = "audiovisual";
    Expertise["BANK_INSURANCE"] = "bank";
    Expertise["COURRIER"] = "courrier";
    Expertise["DIGITAL"] = "digital";
    Expertise["ENERGY"] = "energy";
    Expertise["HUMAN_RESOURCES"] = "human-resource";
    Expertise["INTERNATIONAL"] = "international";
    Expertise["MOBILE"] = "mobile";
    Expertise["PARTNERS"] = "partner";
    Expertise["TRANSVERSE"] = "transverse";
    Expertise["URBAN"] = "urban";
})(Expertise = exports.Expertise || (exports.Expertise = {}));
//# sourceMappingURL=expertise.js.map